// NOTE: This file is maintained in the parent project AS Common.
//       Your application should avoid modifying this file.

import { AppRoot } from "AppRoot";
import { AuthProvider, setupAxios } from "common";
import "common/i18n";
import { createRoot } from "react-dom/client";
import reportWebVitals from "reportWebVitals";

setupAxios();

const container = document.getElementById("root");
const root = createRoot(container);
const isTestEnvironment =
  import.meta.env.DEV && import.meta.env.VITE_ENVIRONMENT === "test";

root.render(
  isTestEnvironment ? (
    <AppRoot />
  ) : (
    // <React.StrictMode>
    <AuthProvider>
      <AppRoot />
    </AuthProvider>
    // </React.StrictMode>
  ),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
